/**
 * @file: formatMoney.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const formatMoney = (
  value: number | null | undefined,
  options?: {
    brackets?: boolean;
    prefix?: boolean;
  },
  fallback = '--',
) => {
  if (value == null) return fallback;
  const s = (value / 100).toFixed(2);
  return [
    options?.brackets ? '(' : '',
    options?.prefix ? '￥' : '',
    s,
    options?.brackets ? ')' : '',
  ].join('');
};
